import get from "lodash/get";

const DEFAULT_STATE = {
  loadingUrls: {},
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getLoadingUrls: (state) => {
      return state.loadingUrls;
    },
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setLoadingUrls: (state, { name, value }) => {
      const [page, method] = name.split(".");
      state.loadingUrls = {
        ...state.loadingUrls,
        [page]: {
          ...state.loadingUrls[page],
          [method]: value,
        },
      };
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateLoadingUrls: ({ commit, state }, { name, value }) => {
      if (typeof value === "function") {
        const currentValue = get(state.loadingUrls, name, undefined);
        commit("setLoadingUrls", {
          name,
          value: value(currentValue),
        });

        return;
      }

      commit("setLoadingUrls", {
        name,
        value,
      });
    },
  },
};
